import React from 'react';

export function Gibraltar(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V228H0V0Z" fill="white"/>
      <path d="M0 228H513V342H0V228Z" fill="#CE1126"/>
      <rect x="216" y="150" width="80" height="78" fill="#CE1126"/>
      <rect x="236" y="130" width="40" height="30" fill="#CE1126"/>
      <rect x="246" y="108" width="20" height="30" fill="#FCD116"/>
    </svg>
  );
}
